export default __webpack_public_path__ + "3e92399b48eaf9a69a8f4d46b363534c.jpg";